import { cva } from "class-variance-authority";
import clsx from "clsx";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { theme } from "antd";

const variants = cva(
  [
    "before:content-['']",
    "before:bg-center",
    "before:bg-no-repeat",
    "before:bg-size-[13px_auto]",
    "before:top-0",
    "before:left-0",
    "before:block",
    "before:w-6",
    "before:absolute",
    "before:h-full",
    "relative",
    "inline-block",
    "pr-2",
    "leading-[32px]",
    "font-bold",
    "overflow-hidden",
    "rounded-lg",
    "text-left",
    "min-w-[90px]",
  ],
  {
    variants: {
      country: {
        NL: ["bg-[#f4be04]", "text-black"],
        BE: ["bg-[#ffffff]", "text-[#ff0000]", "border", "border-[#333]"],
        EU: ["bg-[#dddcd8]", "text-black"],
      },
      size: {
        default: ["w-[150px]"],
        large: [
          "w-full",
          "leading-[40px]",
          "pl-2",
          "text-2xl",
          "font-extrabold",
        ],
        small: [
          "w-[130px]",
          "h-[32px]",
          "leading-[32px]",
          "pl-2",
          "text-sm",
          "font-semibold",
        ],
        full: ["w-full"],
      },
    },
  },
);

const CDN_URL = getConfigValue("cdnUrl");

type LicensePlateCountry = "NL" | "BE" | "EU";

type LicensePlateProps = {
  country?: LicensePlateCountry;
  size?: "default" | "large" | "small" | "full";
  isLoading?: boolean;
  children?: React.ReactNode;
};

const defaultProps: Partial<LicensePlateProps> = {
  country: "NL",
  size: "default",
  isLoading: false,
};

const LicensePlate = ({
  country,
  size,
  isLoading,
  children,
} = defaultProps) => {
  const leftSectionImg = `${CDN_URL}/static/assets/license-plates/${country}-licenseplate.png`;
  const { token } = theme.useToken();

  return (
    <span
      style={{ borderRadius: token?.borderRadius }}
      className={`inline-flex flex-row items-stretch overflow-hidden`}
    >
      <span
        className="w-8 h-auto flex-shrink-0"
        style={{
          backgroundColor: "#365dab",
          backgroundImage: `url('${leftSectionImg}')`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "13px auto",
          display: "inline-block",
        }}
      />

      <span
        className={clsx(
          variants({ country, size }),
          `rounded-l-none ${token?.borderRadius ? "rounded-lg" : "rounded-none"} px-2`,
        )}
      >
        {children}
      </span>
      {isLoading ? (
        <div
          className={`w-6 h-6 absolute right-3 top-2 ${token?.borderRadius ? "rounded-lg" : "rounded-none"} border-2 border-black border-b-transparent animate-spin border-[inherit]`}
        />
      ) : null}
    </span>
  );
};

export { LicensePlate };
